module.exports = __webpack_public_path__ + "static/img/user-comment1.2b34caf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/user-comment1.png
// module id = JRvI
// module chunks = 0